module.exports = __webpack_public_path__ + "static/media/AppStoreBadge.21d84835.png";